export const ENTITY_DIRECTION_TYPE = {
  NOANSWER: 'noanswer',
  REJECTED: 'rejected',
  INBOUND: 'inbound',
  OUTBOUND: 'outbound',
};

export const SIP_DIRECTION_TYPE = {
  INBOUND: 'incoming',
  OUTBOUND: 'outgoing',
};

export const LinkedEntityType = {
  account: 0,
  contact: 1,
  lead: 2,
  systemUser: 5,
} as { [key: string]: number };
